import styled, { css } from 'styled-components';

import { UserPlaceholderImg } from '../../../assets';
import { IconButton } from '../../../components';
import { Button } from '../../../components';
import { bottomNavHeight } from '../../../components/layout/BottomNav/BottomNav.styles';
import { SCROLLABLE_CARD_MIN_WIDTH } from '../../../components/VehicleCard/VehicleBoxesAndActions/VehicleBoxAndActions.styles';
import ZIndexLayers from '../../../services/ZIndexLayers';
import { ThemeProp } from '../../../theme/Themes';
import { setSVGChildColors } from '../../../utils/Listings';

export const ListingTitle = styled.div`
  font-size: ${(props) => props.theme.fontSize.l};
  line-height: ${(props) => props.theme.lineHeight.xl};
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 1rem;
`;

export const StyledButton = styled(Button)`
  && {
    width: 140px;
  }
`;

export const VehicleCardContainer = styled.div`
  z-index: ${ZIndexLayers.elevateOne};
  cursor: pointer;
  // If it is the last element, add bottom padding
  &:last-child {
    padding-bottom: 0.5rem;
  }
`;

export const VehicleCardRightSideContainer = styled(VehicleCardContainer)`
  flex: 1;
  margin-right: 2.25rem;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  height: calc(100vh - 10.5rem); /* This adds the space between cards and bottom of the screen */
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    /* 16rem = Height of views on top of cards (12rem) + height of bottom nav (4rem) */
    height: ${`calc(100dvh - 12rem - ${bottomNavHeight})`};
    padding: 0 1rem;
  }
`;

export const AnswerColorPreview = styled.div<any>`
  background: ${(props) => props.color || 'transparent'};
  width: 0.875rem;
  height: 0.875rem;
  border-radius: 0.5rem;
`;

export interface HeaderIconButtonProps {
  $focused?: boolean;
}

export const headerIconSVGStrokePartial = css`
  svg,
  path,
  circle,
  rect {
    stroke: ${({ theme }: ThemeProp) => theme.colors.greyscale.c100};
  }
`;

export const LISTINGS_ICON_BUTTON_SIZE = '2rem';

export const ListingsIconButton = styled(IconButton)<HeaderIconButtonProps>`
  margin: 0;
  padding: 0;
  width: ${LISTINGS_ICON_BUTTON_SIZE};
  height: ${LISTINGS_ICON_BUTTON_SIZE};
  cursor: pointer;
  border-radius: 50%;
  box-shadow: 0px 1px 4px 0px rgba(41, 12, 55, 0.1); // NOTE: Spec from design system.
  background: ${(props: ThemeProp & HeaderIconButtonProps) =>
    props.$focused ? props.theme.colors.primary.c800 : props.theme.colors.greyscale.c900};

  &:hover {
    background: ${(props) => props.theme.colors.primary.c800};
    ${(props: ThemeProp) => setSVGChildColors(props.theme.colors.primary.c200)}
  }
  ${headerIconSVGStrokePartial}
`;

const CARDS_RIGHT_PADDING = '2.5rem';

export const HorizontalScrollDiv = styled.div`
  min-width: calc(${SCROLLABLE_CARD_MIN_WIDTH} + ${CARDS_RIGHT_PADDING});
  height: 0.625rem;
`;

export const UserAvatarIcon = styled(UserPlaceholderImg)`
  border-radius: 50%;
  overflow: hidden;
`;
